// extracted by mini-css-extract-plugin
export var avatar = "_7-6";
export var brandLink = "_7-0";
export var brandLogo = "_7-1";
export var gear = "_7-7";
export var gearActive = "_7-8";
export var navIcon = "_7-5";
export var navItem = "_7-3";
export var navItemActive = "_7-4";
export var sectionLabel = "_7-2";